
import {Vue} from 'vue-property-decorator'
import Component from 'vue-class-component'
import {Route} from 'vue-router'

import store from '@/store'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate' // for vue-router 2.2+
])

@Component
export default class PageView extends Vue {
  beforeRouteEnter(to: Route, from: Route, next: () => void): void {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title
    }
    store.dispatch(`page/${to.name!}`, {to})
    next()
  }
  beforeRouteUpdate(to: Route, from: Route, next: () => void): void {
    next()
  }
  beforeRouteLeave(to: Route, from: Route, next: () => void): void {
    next()
  }
}
